import { Collection, } from "@bluelibs/x-ui";
import { InboxTask } from "@root/api.types";
import { ClientRequestsCollection, InboxTagsCollection, UsersCollection, } from "@bundles/UIAppBundle/collections";
export class InboxTasksCollection extends Collection {
    getName() {
        return "InboxTasks";
    }
    getInputs() {
        return {
            insert: "InboxTaskInsertInput!",
            update: "InboxTaskUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => ClientRequestsCollection,
                name: "clientRequest",
                field: "clientRequestId",
            },
            {
                collection: () => InboxTagsCollection,
                name: "tag",
                field: "tagId",
            },
            {
                collection: () => UsersCollection,
                name: "assignedTo",
                field: "assignedToId",
            },
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            dueDate: (v) => (v && new Date(v) ? new Date(v) : v),
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
